import React from 'react';
import { ArrowRight, TrendingDown, TrendingUp } from 'lucide-react';
import { analyticsMetricCardClass, analyticsIconChipClass } from './analyticsUi.js';

function AnalyticsStatCard({
  title,
  value,
  subtitle,
  icon: Icon,
  trend,
  color,
  onClick,
  large,
}) {
  return (
    <div
      className={`${analyticsMetricCardClass} ${onClick ? 'cursor-pointer' : ''} ${large ? 'lg:col-span-2' : ''} min-h-0`}
      onClick={onClick}
    >
      {/* Title + icon on one row; value uses full card width so amounts stay on a single line */}
      <div className="flex items-start justify-between gap-2 mb-1 sm:mb-1.5">
        <p className="text-[11px] sm:text-xs lg:text-sm text-gray-600 leading-snug min-w-0">
          {title}
        </p>
        {Icon && (
          <div className={`p-1.5 sm:p-2 rounded-xl shrink-0 border ${analyticsIconChipClass}`}>
            <Icon
              className={`${
                large ? 'w-5 h-5 sm:w-6 sm:h-6' : 'w-3.5 h-3.5 sm:w-4 sm:h-4 lg:w-5 lg:h-5'
              } text-blue-600`}
            />
          </div>
        )}
      </div>

      <h3
        className={`${
          large
            ? 'text-lg sm:text-2xl lg:text-3xl'
            : 'text-[clamp(0.8125rem,1.1vw+0.55rem,1.25rem)]'
        } font-bold text-gray-800 leading-none whitespace-nowrap`}
        title={typeof value === 'string' || typeof value === 'number' ? String(value) : undefined}
      >
        {value}
      </h3>

      {subtitle && (
        <p className="text-[10px] sm:text-xs text-gray-500 mt-1 leading-snug whitespace-nowrap overflow-hidden text-ellipsis">
          {subtitle}
        </p>
      )}

      {trend && (
        <div className="mt-2 sm:mt-3 flex items-center gap-1 whitespace-nowrap">
          {trend.type === 'up' ? (
            <TrendingUp className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-green-500 shrink-0" />
          ) : (
            <TrendingDown className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-red-500 shrink-0" />
          )}
          <span
            className={`text-[10px] sm:text-xs lg:text-sm ${
              trend.type === 'up' ? 'text-green-600' : 'text-red-600'
            }`}
          >
            {trend.value}
          </span>
        </div>
      )}

      {onClick && (
        <div className="mt-2 sm:mt-3 flex items-center text-blue-600 text-xs sm:text-sm whitespace-nowrap">
          <span>View Details</span>
          <ArrowRight className="w-3.5 h-3.5 sm:w-4 sm:h-4 ml-1 shrink-0" />
        </div>
      )}
    </div>
  );
}

export default AnalyticsStatCard;
